<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p>Ex-teacher, university sports officer and tour guide, who took to writing when a teenager and who then got ambushed by marriage, divorce and life in general before deciding to write a miscellaneous collection of short stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b994cea4